import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LoadingService {
    private loadingSubject = new BehaviorSubject<boolean>(false);
    private loadingMessageSubject = new BehaviorSubject<string>('');
    
    public loading$: Observable<boolean> = this.loadingSubject.asObservable();
    public loadingMessage$: Observable<string> = this.loadingMessageSubject.asObservable();

    constructor() {}

    /**
     * Show fullscreen loading overlay
     */
    public show(message: string = 'Loading...'): void {
        this.loadingMessageSubject.next(message);
        this.loadingSubject.next(true);
    }

    /**
     * Hide fullscreen loading overlay
     */
    public hide(): void {
        this.loadingSubject.next(false);
        this.loadingMessageSubject.next('');
    }

    /**
     * Check if loading is currently shown
     */
    public isLoading(): boolean {
        return this.loadingSubject.value;
    }
}
